import { IBasicObject } from "@/interfaces/IBasicObject.ts";
import { IFieldDefinition } from "@/core/libs/FormRequester/types/IFieldDefinition.ts";

export default function defaultCheckAllowed(values: IBasicObject<any>, fieldDefinitions: IBasicObject<IFieldDefinition>) {
  let isAllowed = true;
  for (const key in values) {
    if (fieldDefinitions[key] && !fieldDefinitions[key].required) {
      continue;
    }
    isAllowed = isAllowed && !!values[key];
  }
  return isAllowed;
}
